import { GuidService } from 'ui-components/services/guid-service';
import * as BulkUpdateActions from '../../../store/bulk/update/bulk.update.actions';
import { BulkActions } from '../../../enums/bulk-actions';

export const CustomField3 = {
  id: 'custom-field-3',
  name: BulkActions.customFieldThree.message,

  makeHandler: (dispatch, bulkUpdateTypeData) => {
    return (ids, filters) =>
      dispatch(
        BulkUpdateActions.startBulkUpdateJob(bulkUpdateTypeData, [BulkActions.customFieldThree], ids, GuidService.newGuid(), filters),
      );
  },
};
